function PrimaryButton({ type = "button", children, onClick, fullWidth = false }) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`primary-btn ${fullWidth ? "full-width" : ""}`}
    >
      {children}
    </button>
  );
}

export default PrimaryButton;
